export enum PaymentMethodEnum {
    MB_WAY = "mb-way",
    MULTIBANCO = "mb",
    OPEN_BANKING = "open-banking",
}
